import { useEffect } from "react";
import type { PaymentGatewayProps } from "../../lib/payment-gateways";

export default function PayOnArrivalForm({ onReady }: PaymentGatewayProps) {
  useEffect(() => {
    onReady(true);
  }, [onReady]);
  return (
    <p className="text-sm text-muted-foreground">
      Al check-in presenterai la conferma della prenotazione e provvederai al
      pagamento direttamente in struttura.
    </p>
  );
}
